import React, {PureComponent, ReactNode, StrictMode} from 'react'
import {EquipmentListItemSkeleton} from "@App/Components/Vehicletree/EquipmentList";

export class EquipmentListSkeleton extends PureComponent {
    render(): ReactNode {
        return (
            <StrictMode>
                <div className={'animate-pulse'}>
                    {[...Array(2)].map((e, i) => (<EquipmentListItemSkeleton key={i}/>))}
                    <div className="w-64 bg-black-300 h-8 mt-3 mb-2 rounded-md"/>
                </div>
            </StrictMode>
        )
    }
}
